
export default {
  data() {
    return {
      traderData: {}
    }
  },
  created() {},
  mounted() {
    this.getExchange()
  },
  methods: {
    async getExchange() {
      // 获取交易商数据
      const result = await this.$api.common
        .CV3(
          {},
          {
            Routes: 'wikifx$traderstatisticscountryandlang'
          }
        )
        .catch(() => {
          console.log('traderstatisticscountryandlang')
        })
      if (result && result.wikifx && result.wikifx.traderstatisticscountryandlang) this.traderData = result.wikifx.traderstatisticscountryandlang.data
    }
  }
}
